import { useState } from 'react';
import apiService from '../../axios/apiService';
import { useLocation } from 'react-router-dom';
import { getSearchParamFromLocation } from '../../utils/mapper';
import { message } from 'antd';

export const useClinicStatusUpdate = (initialStatus) => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(initialStatus);
  const location = useLocation();
  const updateClinicStatus = async (status, clinicId) => {
    // Update clinic status
    setLoading(true);
    try {
      setStatus(status);
      const id = clinicId || getSearchParamFromLocation('id', location);
      if (!id) {
        return message.error('Please provide clinic ID');
      }
      const response = await apiService.updateClinicStatus(id, status);
      return response;
    } finally {
      setLoading(false);
      setStatus(undefined);
    }
  };

  return {
    loading,
    status,
    updateClinicStatus,
  };
};
